import { AccountUserType } from '__generated__/atlas-types'

import { FiltersIds, UpsertModalIds } from '../userManagement.ids'
import { FilterOption, UsersTableColumns } from '../userManagement.types'
import messages, { UserTypeLabels } from './userManagement.messages'

export const CONSOLE_LOG_KEY = '[User Management]'

export const OPEN_MODAL_PARAM = 'open-modal'
export const BILLING_CONTACTS_PARAM = 'billing-contacts'

export const STATUS_ACTIVE = 'Active'
export const STATUS_DISABLED = 'Disabled'

export enum LastLoginFilterValue {
  ANY_TIME = 'ANY_TIME',
  LAST_30_DAYS = 'LAST_30_DAYS',
  LAST_60_DAYS = 'LAST_60_DAYS',
  LAST_90_DAYS = 'LAST_90_DAYS',
  LAST_180_DAYS = 'LAST_180_DAYS',
  NEVER_LOGGED_IN = 'NEVER_LOGGED_IN',
}

export const USER_TYPE_FILTER_OPTIONS: FilterOption[] = [
  {
    label: UserTypeLabels[AccountUserType.ADMIN],
    value: AccountUserType.ADMIN,
    key: UsersTableColumns.UserType,
    id: UpsertModalIds.AdminUserTypeOption,
  },
  {
    label: UserTypeLabels[AccountUserType.USER],
    value: AccountUserType.USER,
    key: UsersTableColumns.UserType,
    id: UpsertModalIds.UserTypeOption,
  },
  {
    label: UserTypeLabels[AccountUserType.INTERNAL],
    value: AccountUserType.INTERNAL,
    key: UsersTableColumns.UserType,
    id: UpsertModalIds.InternalUserTypeOption,
  },
  {
    label: UserTypeLabels[AccountUserType.NO_ACCESS],
    value: AccountUserType.NO_ACCESS,
    key: UsersTableColumns.UserType,
    id: UpsertModalIds.NoAccessUserTypeOption,
  },
]

export const STATUS_FILTER_OPTIONS: FilterOption[] = [
  {
    label: STATUS_ACTIVE,
    value: STATUS_ACTIVE,
    key: UsersTableColumns.Status,
    id: UpsertModalIds.ActiveStatusOption,
  },
  {
    label: STATUS_DISABLED,
    value: STATUS_DISABLED,
    key: UsersTableColumns.Status,
    id: UpsertModalIds.DisabledStatusOption,
  },
]

export const LAST_LOGIN_FILTER_OPTIONS: FilterOption[] = [
  {
    label: messages.anyTime,
    value: LastLoginFilterValue.ANY_TIME,
    key: UsersTableColumns.LastLogin,
    id: FiltersIds.AnyTimeOption,
  },
  {
    label: messages.last30Days,
    value: LastLoginFilterValue.LAST_30_DAYS,
    key: UsersTableColumns.LastLogin,
    id: FiltersIds.Last30DaysOption,
  },
  {
    label: messages.last60Days,
    value: LastLoginFilterValue.LAST_60_DAYS,
    key: UsersTableColumns.LastLogin,
    id: FiltersIds.Last60DaysOption,
  },
  {
    label: messages.last90Days,
    value: LastLoginFilterValue.LAST_90_DAYS,
    key: UsersTableColumns.LastLogin,
    id: FiltersIds.Last90DaysOption,
  },
  {
    label: messages.last180Days,
    value: LastLoginFilterValue.LAST_180_DAYS,
    key: UsersTableColumns.LastLogin,
    id: FiltersIds.Last180DaysOption,
  },
  {
    label: messages.neverLoggedIn,
    value: LastLoginFilterValue.NEVER_LOGGED_IN,
    key: UsersTableColumns.LastLogin,
    id: FiltersIds.NeverLoggedInOption,
  },
]

export const INPUT_MAX_LENGTH = 150
export const INPUT_DISPLAY_MAX_LENGTH = 100
export const EMAIL_VALIDATION_REGEX =
  /^((?!.*\.{2})[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-](?:[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~.-]{0,62}[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-])?|"[^"]{1,62}")@([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z0-9]{2,63}$/

export const COLUMN_WIDTH_SELECTION = 40
export const COLUMN_WIDTH_EMAIL = 240
export const COLUMN_WIDTH_SALES_REP = 240
export const COLUMN_WIDTH_REGIONS = 40
export const COLUMN_WIDTH_USER_TYPE = 140
export const COLUMN_WIDTH_LAST_LOGIN = 140
export const COLUMN_WIDTH_STATUS = 140
export const COLUMN_WIDTH_DATA_PERMISSIONS = 160
export const COLUMN_WIDTH_ACTIONS = 60
